import {create} from 'zustand';
import {ProviderNamesStore} from './types';

const useProviderNamesStore = create<ProviderNamesStore>(set => ({
	providersName: null,
	setProvidersName: value => set({providersName: value}),
}));

export {useProviderNamesStore};
